import React, {Fragment} from "react"
import {useListCustomRewardsTransactionsQuery} from "@irati/custom-reward/hooks"
import {CustomRewardTransaction} from "@irati/types"
import {Hr} from "@irati/ui/src/Layout"
import Spacing from "@irati/ui/src/Spacing"
import groupWalletItemsByDate from "@irati/wallet/helpers/groupWalletItemsByDate"
import CustomRewardTransactionItem from "../../StatementItems/StatementItem/CustomReward"
import NoData from "../../NoData"
import {useIntl} from "@irati/utils/lang"
import isMobileDevice from "@irati/utils/mobile"
import Loading from "@irati/ui/src/Loading"
import DateHeader from "../../StatementItems/DateHeader"

const CustomRewardsTransactions = () => {
  const {formatMessage} = useIntl()
  const {data: results, loading} = useListCustomRewardsTransactionsQuery(null)
  const groupedData = groupWalletItemsByDate([], results || [])
  return (
    <Loading isLoading={loading}>
      <Spacing marginTop={2}>
        {groupedData.results.length === 0 && (
          <NoData useCardStyle={isMobileDevice()} text={formatMessage({id: "wallet.noStatementItems.NoCustomRewardsText"})}></NoData>
        )}
        {groupedData.results.map(({data, date}, i) => {
          const key = date.format("YYYY-MM-DD")
          return (
            <Fragment key={key}>
              {i === 0 ? <Spacing marginTop={2} /> : <Hr flush />}
              <DateHeader date={date} />
              {data.map((item: CustomRewardTransaction) => (
                <CustomRewardTransactionItem item={item} key={item.uuid} />
              ))}
            </Fragment>
          )
        })}
      </Spacing>
    </Loading>
  )
}

export default CustomRewardsTransactions
